import React from 'react';
import { LotsPurchaseTabProps } from '../LotsPurchaseTab.type';
import DescriptionList from '../../../../components/DescriptionList';
import DescriptionListItem from '../../../../components/DescriptionListItem';

interface Props {
    reference: LotsPurchaseTabProps['reference'];
    isProcedureRegPrequalification: boolean;
    deliveryRegionCode: string;
    deliveryAddress?: string;
}

const LotDeliveryPlace: React.FC<Props> = ({
    reference,
    isProcedureRegPrequalification,
    deliveryRegionCode,
    deliveryAddress,
}) => {
    if (!deliveryAddress) {
        return null;
    }

    const title = isProcedureRegPrequalification
        ? 'Адрес заказчика, который проводит предквалификацию'
        : 'Место поставки товара, выполнения работ, оказания услуг';

    const getDeliveryRegionName = (code: string): string => {
        const region = reference?.regionsByCode?.[code];
        return `${region?.offName} ${region?.shortName}`;
    };

    return (
        <>
            <h3>{title}</h3>
            <DescriptionList>
                {!!deliveryRegionCode && (
                    <DescriptionListItem
                        title="Регион"
                        definition={getDeliveryRegionName(deliveryRegionCode)}
                    />
                )}

                <DescriptionListItem
                    title="Адрес"
                    definition={deliveryAddress}
                />
            </DescriptionList>
        </>
    );
};

export default React.memo(LotDeliveryPlace);
